module.exports = __webpack_public_path__ + "img/appAsset-brand--compraaqui.aa816f09.svg";